import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export const fmt = (n) => "₹" + Math.round(n || 0).toLocaleString("en-IN");
export const fmtNum = (n) => (n || 0).toLocaleString("en-IN");

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const daysAgoISO = (d) => new Date(Date.now() - d * 86400000).toISOString().slice(0, 10);
export const monthISO = () => new Date().toISOString().slice(0, 7);

export const ragColor = {
  green: "#059669",
  amber: "#C9A24B",
  red: "#DC2626",
};
